import React from "react";
import { Button } from "@/components/ui/button";
import { LifeBuoy } from "lucide-react";
import { useHelp } from "./HelpProvider";

// Reusable "Help me with this page" button. Opens the global route-aware help drawer.
export function HelpButton({ label = "Help with this page", route = null, className = "", testid = "help-page-button" }) {
  const { openHelp } = useHelp();
  return (
    <Button variant="outline" size="sm" data-testid={testid} onClick={() => openHelp(route)}
      className={`h-8 gap-1.5 border-[#D6E0E7] text-[12.5px] ${className}`} style={{ color: "#1C4358" }}>
      <LifeBuoy size={14} /> {label}
    </Button>
  );
}

export default HelpButton;
